var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.deliverableDetail,
          expression: "deliverableDetail"
        }
      ],
      ref: "rootTag",
      attrs: { tabindex: "-1" },
      on: {
        keyup: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])
          ) {
            return null
          }
          $event.stopPropagation()
          return _vm.escapeListener.apply(null, arguments)
        }
      }
    },
    [
      _c("div", { attrs: { id: "social-modal-overlay" } }, [
        _c("div", { ref: "overlayTop", staticClass: "top" }),
        _vm._v(" "),
        _c("div", { ref: "overlayRight", staticClass: "right" }),
        _vm._v(" "),
        _c("div", { ref: "overlayBottom", staticClass: "bottom" }),
        _vm._v(" "),
        _c("div", { ref: "overlayLeft", staticClass: "left" })
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { type: "warn", title: "Override Master Post?" },
          on: {
            hide: function($event) {
              return _vm.seriesModalHidden($event)
            }
          },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                var hide = ref.hide
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.seriesManualUpdateDisabled
                      },
                      on: { click: _vm.clickSeriesModalUpdate }
                    },
                    [_vm._v("\n        Edit Separately From Master\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "danger",
                        disabled: _vm.seriesManualUpdateDisabled
                      },
                      on: { click: _vm.clickSeriesModalCancel }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "secondary",
                        disabled: _vm.seriesManualUpdateDisabled
                      },
                      on: { click: _vm.clickSeriesModalViewMaster }
                    },
                    [_vm._v("\n        Edit Master\n      ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showSeriesManualUpdate,
            callback: function($$v) {
              _vm.showSeriesManualUpdate = $$v
            },
            expression: "showSeriesManualUpdate"
          }
        },
        [
          _c("p", [
            _vm._v(
              "This post will no longer be automatically updated by changes to the master post. Do you want to proceed?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { type: "warn", title: "Rejoin Master Post" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function(ref) {
                var ok = ref.ok
                var cancel = ref.cancel
                return [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.seriesRejoinMasterDisabled
                      },
                      on: { click: _vm.clickConfirmRejoinMaster }
                    },
                    [_vm._v("\n        Rejoin Master\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "danger",
                        disabled: _vm.seriesRejoinMasterDisabled
                      },
                      on: { click: _vm.clickCancelRejoinMaster }
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.showSeriesRejoinMaster,
            callback: function($$v) {
              _vm.showSeriesRejoinMaster = $$v
            },
            expression: "showSeriesRejoinMaster"
          }
        },
        [
          _c("p", [
            _vm._v(
              "Content for this post will be pulled from the master post, and any content or comments specific to this post\n      will be lost. Do you want to proceed?"
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            type: "warn",
            title: "Confirm Deletion",
            "ok-title": "Yes, Delete"
          },
          on: { ok: _vm.onConfirmRemoveDeliverable },
          model: {
            value: _vm.showRemoveDeliverable,
            callback: function($$v) {
              _vm.showRemoveDeliverable = $$v
            },
            expression: "showRemoveDeliverable"
          }
        },
        [_c("p", [_vm._v("Are you sure you want to delete this deliverable?")])]
      ),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.socialModalClass },
        [
          _c(
            "b-tabs",
            {
              ref: "socialModalTabs",
              staticClass: "social-modal-tabs",
              attrs: { "content-class": "mt-3" },
              model: {
                value: _vm.currentTab,
                callback: function($$v) {
                  _vm.currentTab = $$v
                },
                expression: "currentTab"
              }
            },
            [
              _c(
                "b-tab",
                {
                  ref: "tabEditor",
                  attrs: {
                    title: "Editor",
                    active: "",
                    "title-item-class": "tabEditorTitle"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c("span", { staticClass: "nav-item-label" }, [
                            _vm._v("Editor")
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "breadcrumbs-section" },
                    [
                      _c("BreadCrumbs", {
                        attrs: {
                          breadcrumbs: _vm.breadcrumbs,
                          namespace: _vm.namespace
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.getSystemSetting("social_media___enable_social_campaign")
                    ? _c(
                        "section",
                        { staticClass: "settings campaign-settings" },
                        [
                          _c(
                            "div",
                            { staticClass: "settings-header" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName:
                                        "v-b-toggle.collapse-social-campaign-dialog",
                                      modifiers: {
                                        "collapse-social-campaign-dialog": true
                                      }
                                    }
                                  ],
                                  staticClass: "campaign-group-toggle"
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-chevron-right collapse-indicator"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("SocialDeliverableCampaigns", {
                                key: "sdc-" + _vm.deliverableDetail.id,
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  disabled: _vm.showSocialCampaignSettings,
                                  namespace: _vm.namespace
                                },
                                on: {
                                  "click-title": function($event) {
                                    _vm.showSocialCampaignSettings = !_vm.showSocialCampaignSettings
                                  }
                                }
                              }),
                              _vm._v(" "),
                              _c("SocialCampaignTitle", {
                                attrs: {
                                  deliverable: _vm.deliverableDetail,
                                  disabled: !_vm.showSocialCampaignSettings,
                                  namespace: _vm.namespace
                                }
                              }),
                              _vm._v(" "),
                              _vm.isSocialCampaign &&
                              _vm.campaignDetailExists &&
                              1 == 2
                                ? _c(
                                    "div",
                                    [
                                      !_vm.showSocialCampaignSettings
                                        ? _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-toggle",
                                                  rawName:
                                                    "v-b-toggle.collapse-social-campaign-dialog",
                                                  modifiers: {
                                                    "collapse-social-campaign-dialog": true
                                                  }
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                "Show\n                Campaign"
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showSocialCampaignSettings
                                        ? _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-toggle",
                                                  rawName:
                                                    "v-b-toggle.collapse-social-campaign-dialog",
                                                  modifiers: {
                                                    "collapse-social-campaign-dialog": true
                                                  }
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                "Hide\n                Campaign"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isSocialCampaign && _vm.campaignDetailExists
                            ? _c(
                                "b-collapse",
                                {
                                  staticClass: "settings-content-collapse",
                                  attrs: {
                                    id: "collapse-social-campaign-dialog"
                                  },
                                  model: {
                                    value: _vm.showSocialCampaignSettings,
                                    callback: function($$v) {
                                      _vm.showSocialCampaignSettings = $$v
                                    },
                                    expression: "showSocialCampaignSettings"
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "settings-content" },
                                    [
                                      _c("SocialCampaignDialog", {
                                        attrs: {
                                          hideTitle: true,
                                          hideDelete: true,
                                          namespace: _vm.namespace
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.isSocialSeries && _vm.seriesFetched && 1 == 2
                    ? _c(
                        "section",
                        { staticClass: "settings series-settings" },
                        [
                          _c(
                            "div",
                            { staticClass: "settings-header" },
                            [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "b-toggle",
                                      rawName:
                                        "v-b-toggle.collapse-social-series-dialog",
                                      modifiers: {
                                        "collapse-social-series-dialog": true
                                      }
                                    }
                                  ],
                                  staticClass: "campaign-group-toggle"
                                },
                                [
                                  _c("i", {
                                    staticClass:
                                      "fas fa-chevron-right collapse-indicator"
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c("SocialSeriesTitle", {
                                attrs: {
                                  deliverable: _vm.socialSeriesDetail,
                                  disabled: !_vm.showSocialSeriesSettings,
                                  namespace: _vm.namespace
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.showSocialSeriesSettings,
                                      expression: "!showSocialSeriesSettings"
                                    }
                                  ],
                                  staticClass: "pb-0 group-title-wrapper",
                                  on: {
                                    click: function($event) {
                                      _vm.showSocialSeriesSettings = !_vm.showSocialSeriesSettings
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "type-label" }, [
                                    _vm._v("Series")
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "group-title" }, [
                                    _c("div", { staticClass: "group-title" }, [
                                      _c(
                                        "h1",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.editTitle,
                                              expression: "!editTitle"
                                            }
                                          ],
                                          staticClass:
                                            "mb-0 exclude-outside-click project-title"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.socialSeriesDetail.title)
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              false
                                ? _c(
                                    "div",
                                    { staticClass: "settings-header-buttons" },
                                    [
                                      !_vm.showSocialSeriesSettings
                                        ? _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-toggle",
                                                  rawName:
                                                    "v-b-toggle.collapse-social-series-dialog",
                                                  modifiers: {
                                                    "collapse-social-series-dialog": true
                                                  }
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                "Show\n                Series"
                                              )
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.showSocialSeriesSettings
                                        ? _c(
                                            "b-button",
                                            {
                                              directives: [
                                                {
                                                  name: "b-toggle",
                                                  rawName:
                                                    "v-b-toggle.collapse-social-series-dialog",
                                                  modifiers: {
                                                    "collapse-social-series-dialog": true
                                                  }
                                                }
                                              ]
                                            },
                                            [
                                              _vm._v(
                                                "Hide\n                Series"
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-collapse",
                            {
                              staticClass: "settings-content-collapse",
                              attrs: { id: "collapse-social-series-dialog" },
                              model: {
                                value: _vm.showSocialSeriesSettings,
                                callback: function($$v) {
                                  _vm.showSocialSeriesSettings = $$v
                                },
                                expression: "showSocialSeriesSettings"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "settings-content" },
                                [
                                  _c("SocialSeriesDialog", {
                                    attrs: {
                                      hideTitle: true,
                                      namespace: _vm.namespace
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("section", { staticClass: "post-editor-section" }, [
                    _c("div", { staticClass: "details header" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-sm-6 col-md-8" }, [
                          _vm.isMobile()
                            ? _c(
                                "label",
                                {
                                  staticClass:
                                    "form-group w-100 sticky__delv__title"
                                },
                                [
                                  _c(
                                    "h2",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.editTitle,
                                          expression: "!editTitle"
                                        }
                                      ],
                                      staticClass:
                                        "exclude-outside-click edit-d-title deliverable-title",
                                      on: { click: _vm.activateTitleField }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.deliverableDetail.title ||
                                            "Click to set..."
                                        )
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.outside,
                                        expression: "outside"
                                      },
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.editTitle,
                                        expression: "editTitle"
                                      },
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.deliverableDetail.title,
                                        expression: "deliverableDetail.title"
                                      }
                                    ],
                                    ref: "deliverableTitle",
                                    staticClass:
                                      "form-control mb-3 title-field exclude-outside-click h2",
                                    attrs: {
                                      type: "text",
                                      placeholder:
                                        _vm.getDeliverableTitlePlaceholder
                                    },
                                    domProps: {
                                      value: _vm.deliverableDetail.title
                                    },
                                    on: {
                                      change: _vm.onUpdateDeliverableTitle,
                                      blur: function($event) {
                                        _vm.editTitle = false
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          _vm.deliverableDetail,
                                          "title",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "row" }, [
                            _c("div", { staticClass: "col" }, [
                              !_vm.isMobile()
                                ? _c(
                                    "label",
                                    { staticClass: "form-group mb-0 w-100" },
                                    [
                                      _c(
                                        "h2",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.editTitle,
                                              expression: "!editTitle"
                                            }
                                          ],
                                          staticClass:
                                            "exclude-outside-click edit-d-title deliverable-title",
                                          on: { click: _vm.activateTitleField }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.deliverableDetail.title ||
                                                "Click to set..."
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "click-outside",
                                            rawName: "v-click-outside",
                                            value: _vm.outside,
                                            expression: "outside"
                                          },
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.editTitle,
                                            expression: "editTitle"
                                          },
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.deliverableDetail.title,
                                            expression:
                                              "deliverableDetail.title"
                                          }
                                        ],
                                        ref: "deliverableTitle",
                                        staticClass:
                                          "form-control mb-3 title-field exclude-outside-click h2",
                                        attrs: {
                                          type: "text",
                                          placeholder:
                                            _vm.getDeliverableTitlePlaceholder
                                        },
                                        domProps: {
                                          value: _vm.deliverableDetail.title
                                        },
                                        on: {
                                          change: _vm.onUpdateDeliverableTitle,
                                          blur: function($event) {
                                            _vm.editTitle = false
                                          },
                                          input: function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.deliverableDetail,
                                              "title",
                                              $event.target.value
                                            )
                                          }
                                        }
                                      })
                                    ]
                                  )
                                : _vm._e()
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-sm-6 col-md-4" },
                          [
                            _c("SocialStatusLabel", {
                              attrs: {
                                deliverable: _vm.deliverableDetail,
                                namespace: _vm.namespace
                              }
                            })
                          ],
                          1
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details bubble" }, [
                      _c("div", { staticClass: "row social-settings-row" }, [
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("h3", [_vm._v("Languages")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "social-settings-group" }, [
                            _c(
                              "fieldset",
                              { staticClass: "lang social-settings" },
                              [
                                _c("b-form-checkbox-group", {
                                  attrs: {
                                    options: _vm.checkboxLanguageOptions,
                                    name: "languages",
                                    disabled: _vm.languagesDisabled
                                  },
                                  on: { change: _vm.selectedLanguagesUpdated },
                                  model: {
                                    value: _vm.selectedLanguages,
                                    callback: function($$v) {
                                      _vm.selectedLanguages = $$v
                                    },
                                    expression: "selectedLanguages"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-md-6" }, [
                          _c("h3", [_vm._v("Platforms")]),
                          _vm._v(" "),
                          _c("div", { staticClass: "social-settings-group" }, [
                            _c(
                              "fieldset",
                              { staticClass: "network social-settings" },
                              [
                                _c("b-form-checkbox-group", {
                                  attrs: {
                                    options: _vm.checkboxSocialNetworkOptions,
                                    name: "social-networks",
                                    disabled: _vm.socialNetworksDisabled
                                  },
                                  on: {
                                    change: _vm.selectedSocialNetworksUpdated
                                  },
                                  model: {
                                    value: _vm.selectedSocialNetworks,
                                    callback: function($$v) {
                                      _vm.selectedSocialNetworks = $$v
                                    },
                                    expression: "selectedSocialNetworks"
                                  }
                                })
                              ],
                              1
                            )
                          ])
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "details bubble mb-0" }, [
                      _vm.isSocialSeriesMaster(_vm.deliverableDetail.id)
                        ? _c(
                            "div",
                            { staticClass: "social-date-picker-wrap series" },
                            [
                              _c("h3", { staticClass: "posting-dates-title" }, [
                                _vm._v("Posting Dates & Times")
                              ]),
                              _vm._v(" "),
                              _vm._l(
                                _vm.deliverableDetail
                                  .social_series_deliverables,
                                function(seriesDeliverable) {
                                  return !_vm.isSocialSeriesMaster(
                                    seriesDeliverable.id
                                  )
                                    ? _c(
                                        "div",
                                        {
                                          key:
                                            "series-post-" +
                                            seriesDeliverable.id +
                                            "-" +
                                            _vm.refreshKey,
                                          class:
                                            "series-post" +
                                            _vm.seriesPostClass(
                                              seriesDeliverable
                                            )
                                        },
                                        [
                                          _c("SocialSeriesStatusBar", {
                                            attrs: {
                                              deliverable: seriesDeliverable,
                                              namespace: _vm.namespace
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("SocialDatePicker", {
                                            key:
                                              "'socialdatepicker'+deliverableDetail.id+'-'+refreshKey",
                                            attrs: {
                                              deliverableId:
                                                seriesDeliverable.id,
                                              publishDate:
                                                seriesDeliverable.publish_date,
                                              seriesDeliverables:
                                                _vm.deliverableDetail
                                                  .social_series_deliverables,
                                              namespace: _vm.namespace
                                            }
                                          }),
                                          _vm._v(" "),
                                          _c("SocialStatusLabel", {
                                            attrs: {
                                              deliverable: seriesDeliverable,
                                              namespace: _vm.namespace
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                }
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "new-series-post" },
                                [
                                  _c(
                                    "b-modal",
                                    {
                                      attrs: {
                                        id: "seriesAddMultipleDates",
                                        title: "Add Multiple Dates",
                                        size: "lg",
                                        "hide-footer": ""
                                      }
                                    },
                                    [
                                      _c("SocialMultiDatePicker", {
                                        key:
                                          "'socialdatepickermulti'+deliverableDetail.id+'-'+refreshKey",
                                        attrs: {
                                          seriesId:
                                            _vm.deliverableDetail
                                              .social_series[0],
                                          latestPost: _vm.deliverableDetail.social_series_deliverables.at(
                                            -1
                                          ),
                                          seriesDeliverables:
                                            _vm.deliverableDetail
                                              .social_series_deliverables,
                                          namespace: _vm.namespace
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: { variant: "theme" },
                                      on: {
                                        click: _vm.clickSeriesAddMultipleDates
                                      }
                                    },
                                    [_vm._v("Add Multiple Dates")]
                                  )
                                ],
                                1
                              )
                            ],
                            2
                          )
                        : _vm.isSocialSeries
                        ? _c(
                            "div",
                            {
                              staticClass: "social-date-picker-wrap single-post"
                            },
                            [
                              _c("h3", [_vm._v("Posting Date & Time")]),
                              _vm._v(" "),
                              _c("SocialDatePicker", {
                                key:
                                  "socialdatepicker" +
                                  _vm.deliverableDetail.id +
                                  "-" +
                                  _vm.refreshKey,
                                attrs: {
                                  deliverableId: _vm.deliverableDetail.id,
                                  publishDate:
                                    _vm.deliverableDetail.publish_date,
                                  seriesDeliverables:
                                    _vm.deliverableDetail
                                      .social_series_deliverables,
                                  namespace: _vm.namespace
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  on: { click: _vm.clickSeriesModalViewMaster }
                                },
                                [_vm._v("Edit Master Post")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                { on: { click: _vm.clickSeriesRejoinMaster } },
                                [_vm._v("Rejoin Master Post")]
                              )
                            ],
                            1
                          )
                        : _c(
                            "div",
                            {
                              staticClass: "social-date-picker",
                              attrs: {
                                id:
                                  "socialdatepicker-wrapper" +
                                  _vm.deliverableDetail.id
                              }
                            },
                            [
                              _c("h3", [_vm._v("Posting Date & Time")]),
                              _vm._v(" "),
                              _c("SocialDatePicker", {
                                key:
                                  "socialdatepicker" +
                                  _vm.deliverableDetail.id +
                                  "-" +
                                  _vm.refreshKey,
                                attrs: {
                                  deliverableId: _vm.deliverableDetail.id,
                                  publishDate:
                                    _vm.deliverableDetail.publish_date,
                                  namespace: _vm.namespace
                                }
                              }),
                              _vm._v(" "),
                              _vm.getSystemSetting(
                                "social_media___enable_social_series"
                              )
                                ? _c(
                                    "b-button",
                                    {
                                      class: "btn-theme",
                                      on: {
                                        click:
                                          _vm.createSocialSeriesFromDeliverable
                                      }
                                    },
                                    [_vm._v("Enable Multiple Dates")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        ref: "refPostEditor",
                        staticClass: "details post-editor"
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "post-editor-wrap" },
                          _vm._l(_vm.deliverableDetail.languages, function(
                            language
                          ) {
                            return _c(
                              "div",
                              { staticClass: "post-editor-language" },
                              [
                                _c(
                                  "div",
                                  {
                                    class:
                                      "language-" +
                                      _vm.languages.find(function(lang) {
                                        return lang.id == language
                                      }).lang_code
                                  },
                                  _vm._l(
                                    _vm.deliverableDetail.social_posts,
                                    function(socialPost) {
                                      return _c("SocialPostEditor", {
                                        key: socialPost.id,
                                        attrs: {
                                          lang: _vm.systemSettings.languages.find(
                                            function(lang) {
                                              return lang.id == language
                                            }
                                          ),
                                          post: socialPost,
                                          namespace: _vm.namespace
                                        }
                                      })
                                    }
                                  ),
                                  1
                                )
                              ]
                            )
                          }),
                          0
                        )
                      ]
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "section",
                    {
                      staticClass: "tasks-section",
                      class: { disabled: _vm.isPublishedPost }
                    },
                    [
                      _c("div", { staticClass: "form-group" }, [
                        _c(
                          "div",
                          { staticClass: "tags__wrapper" },
                          [
                            _c("DeliverableListTags", {
                              attrs: {
                                deliverable: _vm.deliverableDetail,
                                namespace: _vm.namespace
                              }
                            })
                          ],
                          1
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "details brief-editor" },
                        [
                          _c("h3", [_vm._v("Notes")]),
                          _vm._v(" "),
                          _vm.deliverableDetail.deliverableId && _vm.description
                            ? _c("ckeditor", {
                                attrs: {
                                  editorUrl: "/js/ckeditor/ckeditor.js",
                                  id:
                                    "deliverable-description-" +
                                    _vm.deliverableDetail.deliverableId,
                                  config: _vm.editorConfig,
                                  editorDisabled: _vm.descriptionDisabled
                                },
                                on: { blur: _vm.deliverableDescriptionUpdated },
                                model: {
                                  value: _vm.description,
                                  callback: function($$v) {
                                    _vm.description = $$v
                                  },
                                  expression: "description"
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          {
                            ref: "refTaskFieldsWrapper",
                            staticClass: "col-md-12"
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "add-task-button-mobile" },
                              [
                                _vm.canCreateTask()
                                  ? _c(
                                      "b-button",
                                      {
                                        staticClass: "add-task-btn",
                                        attrs: { variant: "theme" },
                                        on: {
                                          click: function($event) {
                                            $event.stopPropagation()
                                            return _vm.createTask.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                  Add Task\n                  "
                                        ),
                                        _c(
                                          "div",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: _vm.addingTask,
                                                expression: "addingTask"
                                              }
                                            ],
                                            staticClass:
                                              "ml-2 spinner-border spinner-border-sm text-primary",
                                            attrs: { role: "status" }
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "sr-only" },
                                              [_vm._v("Loading...")]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("TaskFieldLabels", {
                              ref: "TaskFieldLabelsRef",
                              attrs: {
                                fullDeliverables: _vm.deliverableDetail,
                                deliverableId:
                                  _vm.deliverableDetail.deliverableId,
                                deliverable: _vm.deliverableDetail,
                                tasks: _vm.deliverableDetail.tasks,
                                namespace: _vm.namespace
                              }
                            }),
                            _vm._v(" "),
                            _c("TaskFields", {
                              attrs: {
                                fullDeliverables: _vm.deliverableDetail,
                                deliverableId:
                                  _vm.deliverableDetail.deliverableId,
                                deliverable: _vm.deliverableDetail,
                                tasks: _vm.deliverableDetail.tasks,
                                namespace: _vm.namespace
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              ref: "refBelowTasks",
                              staticClass: "below-tasks"
                            })
                          ],
                          1
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("section", { staticClass: "footer-controls-section" }, [
                    _vm.userAbilities.deleteMediaCall &&
                    _vm.deliverableDetail.permissions &&
                    !_vm.deliverableDetail.permissions.viewOnly &&
                    !_vm.isPublishedPost
                      ? _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true }
                              }
                            ],
                            staticClass: "btn delete-deliverable-btn",
                            attrs: { title: _vm.getDeleteDeliverableTitle },
                            on: {
                              click: function($event) {
                                return _vm.removeDeliverable(
                                  _vm.deliverableDetail.deliverableId
                                )
                              }
                            }
                          },
                          [_c("i", { staticClass: "fas fa-trash-alt" })]
                        )
                      : _vm._e()
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  ref: "tabComments",
                  attrs: {
                    title: "Comments",
                    "title-item-class": "tabCommentsTitle"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c("span", { staticClass: "nav-item-label" }, [
                            _vm._v("Comments")
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "breadcrumbs-section" },
                    [
                      _c("BreadCrumbs", {
                        attrs: {
                          breadcrumbs: _vm.breadcrumbs,
                          namespace: _vm.namespace
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "comments-section" },
                    _vm._l(_vm.deliverableDetail.languages, function(language) {
                      return _c(
                        "div",
                        { staticClass: "language-group" },
                        [
                          _c("h2", { staticClass: "lang-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.systemSettings.languages.find(function(
                                  lang
                                ) {
                                  return lang.id == language
                                }).lang_name
                              )
                            )
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.deliverableDetail.social_posts, function(
                            social_post
                          ) {
                            return social_post.lang_id == language
                              ? _c(
                                  "div",
                                  { staticClass: "post-group" },
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-toggle",
                                            rawName: "v-b-toggle",
                                            value:
                                              "comments-toggle-" +
                                              social_post.id,
                                            expression:
                                              "`comments-toggle-${social_post.id}`"
                                          }
                                        ],
                                        staticClass: "post-group-toggle"
                                      },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fas fa-chevron-right collapse-indicator"
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          social_post.social_networks,
                                          function(network) {
                                            return _c("i", {
                                              class:
                                                "fab fa-" +
                                                _vm.getSocialNetworkClassFromId(
                                                  network
                                                ) +
                                                " platform-indicator",
                                              attrs: {
                                                title: _vm.getSocialNetworkNameFromId(
                                                  network
                                                )
                                              }
                                            })
                                          }
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "comment-count" },
                                          [
                                            _vm._v(
                                              "\n                  (" +
                                                _vm._s(
                                                  _vm.displayPostCommentCount(
                                                    social_post
                                                  )
                                                ) +
                                                ")\n                "
                                            )
                                          ]
                                        )
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "b-collapse",
                                      {
                                        attrs: {
                                          visible: "",
                                          id:
                                            "comments-toggle-" + social_post.id
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "platform-group-content"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "details post-image-details"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-6"
                                                      },
                                                      [
                                                        !social_post.files
                                                          .length
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "no-images"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "No images."
                                                                )
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "image-group"
                                                              },
                                                              [
                                                                _c(
                                                                  "SocialPostImageSlider",
                                                                  {
                                                                    attrs: {
                                                                      socialPost: social_post,
                                                                      location:
                                                                        "comments",
                                                                      namespace:
                                                                        _vm.namespace
                                                                    }
                                                                  }
                                                                )
                                                              ],
                                                              1
                                                            )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-6 comments-col"
                                                      },
                                                      [
                                                        _c(
                                                          "SocialPostCommentEditor",
                                                          {
                                                            key:
                                                              "social-post-" +
                                                              social_post.id +
                                                              "-comments-image",
                                                            attrs: {
                                                              socialPost: social_post,
                                                              commentField:
                                                                "image",
                                                              namespace:
                                                                _vm.namespace
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "details post-caption-details"
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "col-md-6"
                                                      },
                                                      [
                                                        !social_post.caption
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "no-caption"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "No post copy."
                                                                )
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "caption-wrap"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                          " +
                                                                _vm._s(
                                                                  social_post.caption
                                                                ) +
                                                                "\n                        "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-6 comments-col"
                                                      },
                                                      [
                                                        _c(
                                                          "SocialPostCommentEditor",
                                                          {
                                                            key:
                                                              "social-post-" +
                                                              social_post.id +
                                                              "-comments-caption",
                                                            attrs: {
                                                              socialPost: social_post,
                                                              commentField:
                                                                "caption",
                                                              namespace:
                                                                _vm.namespace
                                                            }
                                                          }
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          })
                        ],
                        2
                      )
                    }),
                    0
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  ref: "tabSummary",
                  staticClass: "tab-pane__summary",
                  attrs: {
                    title: "Summary",
                    "title-item-class": "tabSummaryTitle"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function() {
                        return [
                          _c("span", { staticClass: "nav-item-label" }, [
                            _vm._v("Summary")
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "breadcrumbs-section" },
                    [
                      _c("BreadCrumbs", {
                        attrs: {
                          breadcrumbs: _vm.breadcrumbs,
                          namespace: _vm.namespace
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isSocialSeries &&
                  _vm.seriesFetched &&
                  !_vm.deliverableDetail.is_master
                    ? _c(
                        "section",
                        { staticClass: "settings series-settings" },
                        [
                          _c("div", { staticClass: "settings-header" }, [
                            _c(
                              "div",
                              { staticClass: "settings-header-title" },
                              [
                                _c("div", { staticClass: "department-label" }, [
                                  _vm._v("Series:")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "department-title" }, [
                                  _vm._v(_vm._s(_vm.socialSeriesDetail.title))
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "settings-header-buttons" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    on: {
                                      click: _vm.clickSeriesModalViewMaster
                                    }
                                  },
                                  [_vm._v("View Master Post")]
                                )
                              ],
                              1
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "summary-languages" },
                    _vm._l(_vm.deliverableDetail.languages, function(language) {
                      return _c(
                        "div",
                        { staticClass: "summary-language" },
                        _vm._l(_vm.deliverableDetail.social_posts, function(
                          social_post
                        ) {
                          return social_post.lang_id == language
                            ? _c("div", { staticClass: "summary-post" }, [
                                _c(
                                  "div",
                                  { staticClass: "summary-post-header" },
                                  [
                                    _c(
                                      "h3",
                                      { staticClass: "language-heading" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.systemSettings.languages.find(
                                              function(lang) {
                                                return lang.id == language
                                              }
                                            ).lang_name
                                          ) + "\n                "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "platforms" }, [
                                      _c(
                                        "h4",
                                        _vm._l(
                                          social_post.social_networks,
                                          function(network) {
                                            return _c("i", {
                                              class:
                                                "fab fa-" +
                                                _vm.getSocialNetworkClassFromId(
                                                  network
                                                ) +
                                                " platform-indicator",
                                              attrs: {
                                                title: _vm.getSocialNetworkNameFromId(
                                                  network
                                                )
                                              }
                                            })
                                          }
                                        ),
                                        0
                                      )
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "summary-images social-image-slider"
                                  },
                                  [
                                    _c("SocialPostImageSlider", {
                                      attrs: {
                                        socialPost: social_post,
                                        location: "summary",
                                        namespace: _vm.namespace
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "summary-caption" }, [
                                  _c("div", { staticClass: "caption-text" }, [
                                    !social_post.caption
                                      ? _c(
                                          "span",
                                          { staticClass: "no-caption" },
                                          [_vm._v("No post copy.")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    social_post.caption
                                      ? _c(
                                          "div",
                                          { staticClass: "caption-wrap" },
                                          [
                                            _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.formatCaptionText(
                                                    social_post.caption
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-text btn-copy",
                                                attrs: {
                                                  id:
                                                    "copy-post-btn-" +
                                                    social_post.id,
                                                  type: "button",
                                                  "data-dismiss": "modal"
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.copyFn(
                                                      social_post.caption,
                                                      social_post.id
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("i", {
                                                  class: _vm.getCopyIconClass(
                                                    social_post.id
                                                  )
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "b-tooltip",
                                              {
                                                attrs: {
                                                  target:
                                                    "copy-post-btn-" +
                                                    social_post.id,
                                                  triggers: "hover",
                                                  noninteractive: ""
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.getCopyTooltipText(
                                                      social_post.id
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ])
                            : _vm._e()
                        }),
                        0
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _vm.hasFilesToDownload
                    ? _c("section", { staticClass: "summary-images" }, [
                        _c(
                          "h6",
                          {
                            staticClass: "summary-download-images-link",
                            attrs: { title: "Download Images" },
                            on: { click: _vm.downloadImagesZip }
                          },
                          [
                            _vm._v("Download Images\n            "),
                            _c("i", { staticClass: "fas fa-download" })
                          ]
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "summary-schedule" },
                    [
                      _c("SocialSummarySchedule", {
                        attrs: {
                          deliverable: _vm.deliverableDetail,
                          namespace: _vm.namespace
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "section",
                    { staticClass: "summary-controls" },
                    [
                      _c("SocialSummaryControls", {
                        attrs: { namespace: _vm.namespace },
                        on: {
                          "task-status-updated": _vm.updateDeliverableTasks
                        }
                      })
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c("b-tab", {
                attrs: {
                  "title-link-class": "close-tab-link",
                  "title-item-class": "close-tab"
                },
                on: { click: _vm.onCloseModal },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function() {
                      return [_c("i", { staticClass: "fas fa-times" })]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }